import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=34044093&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=34044093&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports